import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const NavigationBarChatIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{ width: '20px', height: '20px', ...sx }}
    {...props}
  >
    <path
      d="M19 8h-1V5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v12a1 1 0 0 0 .62.92 1 1 0 0 0 1.09-.21l2.81-2.82H8v1.44a3 3 0 0 0 3 3h6.92l2.37 2.38a1 1 0 0 0 1.54-.16A1 1 0 0 0 22 21V11a3 3 0 0 0-3-3ZM8 11v1.89H6.11a1 1 0 0 0-.71.29L4 14.59V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v3h-5a3 3 0 0 0-3 3Zm12 7.59-1-1a1 1 0 0 0-.71-.3H11a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v7.59Z"
      fill="url(#a)"
    />
    <path
      d="M19 8h-1V5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v12a1 1 0 0 0 .62.92 1 1 0 0 0 1.09-.21l2.81-2.82H8v1.44a3 3 0 0 0 3 3h6.92l2.37 2.38a1 1 0 0 0 1.54-.16A1 1 0 0 0 22 21V11a3 3 0 0 0-3-3ZM8 11v1.89H6.11a1 1 0 0 0-.71.29L4 14.59V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v3h-5a3 3 0 0 0-3 3Zm12 7.59-1-1a1 1 0 0 0-.71-.3H11a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v7.59Z"
      fill="url(#b)"
    />
    <defs>
      <linearGradient
        id="a"
        x1="12"
        y1="2"
        x2="12"
        y2="22.1"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#96C93D" />
        <stop offset="1" stopColor="#00B09B" />
      </linearGradient>
      <linearGradient
        id="b"
        x1="12"
        y1="22"
        x2="12"
        y2="2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F4D03F" />
        <stop offset="1" stopColor="#16A085" />
      </linearGradient>
    </defs>
  </SvgIcon>
)

NavigationBarChatIcon.defaultProps = {
  sx: null,
}
